var _defs, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHexagonOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "-5 -5 310 310"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".HexagonOutline-1 { fill: transparent; opacity: 0.5; stroke: currentColor; stroke-width: 1%; }"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  className: "HexagonOutline-1",
  points: "300,150 225,280 75,280 0,150 75,20 225,20"
})));
export default SvgHexagonOutline;